<div class="commands d-flex flex-wrap" [ngStyle]="qmStyle">

  <!-- INFO -->
  <ng-container *qmAuth="'ElementInfo'">
    <ng-container *ngIf='visibleButtons.info'>
      <ng-container [ngSwitch]="tenant">
        <!-- Common -->
        <qm-info-action
          *ngSwitchDefault
          #actionButtonCommon
          class="action-button"
          [selectedFeature]="selectedFeature"
          [selectedLayer]="selectedLayer"
          (detailsOpened)="onDetailsOpened()">
        </qm-info-action>
        <!-- VR variant -->
        <qm-info-action
          *ngSwitchCase="2"
          #actionButtonVrVariant
          class="action-button"
          tooltipContents="{{ 'Open train info' | translate }}"
          [selectedFeature]="selectedFeature"
          [selectedLayer]="selectedLayer"
          [tabId]="'schedule'"
          (show)="setVrInfoVisibility($event)"
          (detailsOpened)="onDetailsOpened()">
        </qm-info-action>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Only VR, Button to open cargo manifest -->
  <ng-container *qmAuth="'ElementInfo'">
    <ng-container *ngIf="visibleButtons.cargoManifest && tenant === 2">
        <qm-info-action
          class="action-button"
          tooltipContents="{{ 'Open cargo manifest' | translate }}"
          [selectedFeature]="selectedFeature"
          [selectedLayer]="selectedLayer"
          [tabId]="'cargomanifest'"
          [icon]="'file-alt'"
          (show)="setVrInfoVisibility($event)"
          (detailsOpened)="onDetailsOpened()">
        </qm-info-action>
    </ng-container>
  </ng-container>

  <!-- FLAG -->
  <qm-flag-action
    *ngIf="visibleButtons.flag"
    class="action-button"
    [feature]="selectedFeature"
    [userName]="userName">
  </qm-flag-action>

  <!-- FOCUS -->
  <ng-container *ngIf="visibleButtons.focus">
    <qm-focus-action
      class="action-button"
      [selectedFeature]="selectedFeature">
    </qm-focus-action>
  </ng-container>

  <ng-container *ngIf="tenant === 2 && visibleButtons.follow">
    <qm-follow-train-button [feature]="selectedFeature" class="action-button"></qm-follow-train-button>
  </ng-container>

  <!--
  <a [attr.data-btnId]="getElementId('openNotification')" class="" *qmAuth="'Notification'"
     (click)="openDetails('Notification')">
    <span class="fa-layers fa-fw" style="font-size: 1em;">
      <svg class="svg-inline--fa fa-w-20">
        <use xlink:href="#sticky"></use>
      </svg>
      <span class="fa-layers-counter fa-1x" *ngIf="counter.messages > 0"
            style="background: deepskyblue;font-size: 1.8em;">{{counter.messages}}</span>
    </span>
  </a>
  -->

  <!-- VIVO LINK -->
  <ng-container *qmAuth="'vivo'">
    <a class="action-button" [style.fontSize]="'.7em'" *ngIf="vivoId" [href]="getVivoLink()" target="_blank">
      VIVO
    </a>
  </ng-container>

</div>
